import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, UrlTree } from "@angular/router";
import { FeatureFlagService } from "./feature-flag.service";

/**
 * Uso: `canActivate: [FeatureFlagGuard], data: { featureFlag: 'NFSE' }`.
 * Flag desligada: AdminRenova entra (a tela mostra o aviso); os demais vão para `data.redirectTo`.
 */
@Injectable({ providedIn: "root" })
export class FeatureFlagGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private featureFlags: FeatureFlagService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.featureFlags.ensureLoaded().pipe(map(() => this.check(route)));
  }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.featureFlags.ensureLoaded().pipe(map(() => this.check(route)));
  }

  private check(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const flag = route.data?.featureFlag;
    if (!flag || this.featureFlags.isEnabled(flag) || this.featureFlags.isAdmin()) {
      return true;
    }
    return this.router.createUrlTree([route.data?.redirectTo || "/operacao/vistorias"]);
  }
}
